module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Ikmēneša rēķini")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui segment",
    class: {
      loading: _vm.storeStatus.loading
    }
  }, [_c('table', {
    staticClass: "ui selectable table orange"
  }, [(!_vm.checkClientWidth) ? _c('thead', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ramus_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((item.amount * (-1)).toFixed(2)) + " €")]), _vm._v(" "), _c('td', [(item.ramus_id != '') ? _c('a', {
      staticClass: "ms-pointer",
      on: {
        "click": function($event) {
          return _vm.getPdf(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "file pdf outline icon"
    }), _vm._v("Lejupielādēt pavadzīmi")]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('paginator', {
    attrs: {
      "paginator": _vm.paginator,
      "link-name": "user-monthly-bills-page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Datums")]), _vm._v(" "), _c('th', [_vm._v("Pavadzīmes Nr.")]), _vm._v(" "), _c('th', [_vm._v("Kopsumma")]), _vm._v(" "), _c('th', [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-364873b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserMonthlyBillsPage.vue
// module id = 338
// module chunks = 1